export const general = {
    class: "분류",
    professor: "교수",
    description: "설명",
    grade: "성적",
    load: "널널",
    speech: "강의",
    upload: "업로드",
    numClasses: "강의시간",
    numLabs: "실험",
    credit: "학점",
    cancel: "취소",
    save: "저장",
    edit: "수정",
    hours: "시간",
    minutes: "분",
    seconds: "초",
    am: "오전",
    pm: "오후",
    year: "연도",
    room: "장소",
    language: "언어",
    limit: "정원",
    exam: "시험",
    completedCourse: "수강완료",
    wishlist: "찜목록",
    offline: {
        title: "서버 연결 실패",
        description: "서버에 연결할 수 없습니다. 인터넷 연결을 확인해 주세요.",
        goHome: "홈으로 돌아가기",
        retry: "다시 시도",
        banner: "오프라인 상태입니다. 현재 세션에 불러온 데이터만 표시됩니다.",
        navDisabled: "오프라인 모드에서는 이용할 수 없습니다",
    },
    serverError: {
        title: "서버 장애",
        apology: "불편을 드려 죄송합니다",
        description: "현재 서버에 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.",
        goHome: "홈으로 돌아가기",
        retry: "다시 시도",
    },
    notFound: {
        title: "페이지를 찾을 수 없습니다",
        description: "요청하신 페이지가 존재하지 않거나 이동되었습니다.",
        goHome: "홈으로 돌아가기",
    },
    toOTLV3: "이전 버전",
}
